import React from 'react'
import CommentItem from './CommentItem'
import moment from 'moment'

const CommentList = (props) => {
    return (
        <ul>
            {props.comments.map((c, idx) =>
                <CommentItem
                    key={idx}
                    idx={idx + 1}
                    id={c.TalkbackId}
                    title={c.Title}
                    content={c.Content}
                    author={c.AuthorName}
                    likes={c.LikeCount}
                    dislikes={c.DislikeCount}
                    publishDate={moment(c.Created).format('(hh:mm MM/DD/YYYY)')}
                    replies={c.FollowUps}
                    articleRef={props.articleRef}
                />)}
        </ul>
    )
}

export default CommentList;


// WEBPACK FOOTER //
// ./src/Components/comments/CommentList.jsx